import React from "react";
import Fade from "react-reveal/Fade";
const SkillsCard = ({ skillsdata }) => {
	return (
		<Fade left>
			<div className="m-2 text-center  py-3">
				<li style={{ listStyleType: "none", fontSize: "20px", borderRight: "10px solid #28A745" }} className='card  p-2'>
					{skillsdata.name}
				</li>
			</div>
		</Fade>
   
	);
};

export default SkillsCard;
